import { Col, Row } from "antd";
import { IoIosArrowRoundBack } from "react-icons/io";
import { useNavigate } from "react-router-dom";

const ViewNotification = () => {
  const navigate = useNavigate();

  return (
    <Row justify="center">
      <Col md={23} xs={22}>
        <div
          className="bg-white rounded-lg sm:py-16 py-8 my-12"
          style={{ boxShadow: "1px 1px 1px 1px rgba(0, 0, 0, 0.05)" }}
        >
          <div className="flex justify-start mx-1 lg:mx-8 mb-6">
            <div className="flex justify-center items-center">
              <IoIosArrowRoundBack
                onClick={() => navigate(-1)}
                className="self-center cursor-pointer mr-1 w-[48px] h-[48px] max-sm:w-[24px] max-sm:h-[24px] text-black"
              />
              <h3 className="font-tavi lg:text-3xl text-2xl max-sm:text-lg font-normal text-black">
                View Push Notifications
              </h3>
            </div>
          </div>

          <Row justify="center">
            <Col xs={22} sm={18} md={18} xl={12}>
              <div className="bg-[#EBEBEB] rounded-lg flex flex-col items-start justify-center sm:p-12 p-6">
                <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                  Title
                </h5>
                <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                  ABC Title
                </p>
                <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                  User Type
                </h5>
                <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                  Driver
                </p>
                <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                  Description
                </h5>
                <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the when an unknown printer
                  took a galley of type and scrambled it to make a type specimen
                  book.
                  <br />
                  It has survived not only five centuries, but also the leap
                  into electronic typesetting, remaining essentially unchanged.
                  It was popularised in the with the release of Letraset sheets
                  containing.
                </p>
              </div>
            </Col>
          </Row>
        </div>
      </Col>
    </Row>
  );
};

export default ViewNotification;
